<app-crudbar-nav [title]="title" (onReady)="doComReady($event,'crudbar-nav')">
</app-crudbar-nav>

<mat-tab-group #masterTabGroup mat-stretch-tabs="false" mat-align-tabs="start" class="h-full"
  style="vertical-align: top;" animationDuration="0ms" dynamicHeight (selectedTabChange)="onMasterTabChange($event)">
  <mat-tab #myTabGrid label="瀏覽">
    <div class="border-2 border-red-300">
      <app-jkaggrid #myGrid [columnDefs]="srv.columnDefs" (afterGridReadyAg)="afterGridReady($event)"
        (rowClicked)="agRowClicked($event)" (rowSelected)="agRowSelected($event)" (onInsert)="doUIInsert($event)"
        (onDelete)="doUIDelete($event)"></app-jkaggrid>

    </div>
  </mat-tab>

  <mat-tab #myTabDetail label="明細">
    <!-- <app-mtrwl-tabedit [srv]="srv"></app-mtrwl-tabedit> -->
    <div style="max-height: 400px; overflow-y: auto;">
      <div class="jk-grid-cols-2">
        <app-jkcheckboxYN label="星號" #WL008Com id="WL008" [(valueYN)]="item.WL008" [readonly]="true">
        </app-jkcheckboxYN>
        <app-jktext label="序號" [value]="item.WL002">
        </app-jktext>
        <app-jknumberedit label="排序碼" #WL003Com id="WL003" [(value)]="item.WL003" [readonly]="true">
        </app-jknumberedit>
        <app-jkdatefield label="日期" #WL005Com id="WL005" [(value)]="item.WL005" [readonly]="true">
        </app-jkdatefield>
        <app-jktextarea height="250px" label="內文" #WL004Com id="WL004" [(value)]="item.WL004" [readonly]="true">
        </app-jktextarea>
        <app-jktextarea height="250px" label="html內文" #WL013Com id="WL013" [(value)]="item.WL013" [readonly]="true">
        </app-jktextarea>
        <app-jktextarea height="250px" label="主旨" #WL007Com id="WL007" [(value)]="item.WL007" [readonly]="true">
        </app-jktextarea>
        <app-jkcheckboxYN label="tag" #WL011Com id="WL011" [(valueYN)]="item.WL011" [readonly]="true">
        </app-jkcheckboxYN>
        <app-jktext label="格式" [value]="item.WL012">
        </app-jktext>
        <app-jktext label="股票代號" [value]="item.WL010">
        </app-jktext>
        <app-jktext label="來源單號" [value]="item.WL009">
        </app-jktext>
        <app-jkdatefield label="Date" #WL006Com id="WL006" [(date)]="item.WL006" [readonly]="true">
        </app-jkdatefield>
        <app-jktext label="單號" [value]="item.WL001">
        </app-jktext>

      </div>
    </div>
  </mat-tab>

  <mat-tab #myTabAdvance label="進階">
    <div class="border-2 min-h-[200px]">[空白]</div>
  </mat-tab>
</mat-tab-group>